import React from 'react';
import { useDispatch } from 'react-redux';
import Loader from 'react-loader-spinner';
import { useSelect, useSelectWithParams } from '../../../../../../utils/selector.utils';
import { authSelectors } from '../../../../../../app/auth/auth.selectors';
import { userSelectors } from '../../../../../../app/resource/user/user.selectors';
import { syncUserWithSlack } from '../../../../../../app/page/page-storage/users/users.actions';
import { ISettings } from '../../../../../../app/resource/settings/settings.types';
import { useApiRequestState } from '../../../../../../utils/api.utils';

export const SlackIntegration = ({ settings }: { settings: ISettings }) => {
  const dispatch = useDispatch();
  const loggedUserId = useSelect(authSelectors.selectLoggedUser);
  const loggedUser = useSelectWithParams(userSelectors.selectResourceById, loggedUserId ?? '');

  const [showSlackLoader] = useApiRequestState('syncUserWithSlack');

  const url = new URL('https://slack.com/oauth/v2/authorize');
  url.searchParams.set('client_id', process.env.REACT_APP_SLACK_CLIENT_ID || '');
  url.searchParams.set('scope', 'chat:write,users:read,users:read.email');
  url.searchParams.set('state', `TENANT_ID_${loggedUser?.tenantId}`);
  url.searchParams.set('redirect_uri', process.env.REACT_APP_SLACK_REDIRECT_URI || '');

  const handleSyncUsersWithSlack = () => {
    dispatch(syncUserWithSlack());
  };

  return (
    <div className="border-bottom my-2">
      {settings?.slackWorkspaceName ? (
        <div className="row">
          <div className="col-12 pr-1">
            <div className="f-14">
              Integrated with Slack Workspace <span className="bold">{settings.slackWorkspaceName}</span>
            </div>
            <button
              className="flex align-center p-1 btn white-bg btn-border my-2"
              onClick={handleSyncUsersWithSlack}
              style={{ pointerEvents: 'auto', height: 32 }}
              type="button"
            >
              {showSlackLoader ? (
                <Loader type="TailSpin" color="var(--theme-primary-color)" height={20} width={20} />
              ) : (
                <>
                  <img
                    alt="Slack"
                    height="20"
                    width="20"
                    src="https://a.slack-edge.com/80588/marketing/img/icons/icon_slack_hash_colored.png"
                  />
                </>
              )}
              <span className="ml-1">Sync users with Slack</span>
            </button>
          </div>
        </div>
      ) : (
        <a className="ml-3" href={url.toString()}>
          <img
            alt="Add to Slack"
            height="40"
            width="139"
            src="https://platform.slack-edge.com/img/add_to_slack.png"
            srcSet="https://platform.slack-edge.com/img/add_to_slack.png 1x, https://platform.slack-edge.com/img/add_to_slack@2x.png 2x"
          />
        </a>
      )}
    </div>
  );
};
